import React, {PureComponent} from 'react';
import Loading from "../../subComponents/GenericLoading/loading";
import PropTypes from 'prop-types';
import Connect from "react-redux/es/connect/connect";
import {withTranslation} from "react-i18next";
import Table from "react-bootstrap/Table";
import {getPublishedArticles} from "../../../actions";
import Pagination from "../../subComponents/GenericPagination";
import Config from "../../../config";
import ArrowRight from "../../../assets/arrow-right.png";
import ArrowLeft from "../../../assets/arrow-left.png";
import SuperModal from "../../subComponents/GenericModal/superModal";
import NewsGalleryBlack from "../../../assets/news_gallery_black.png";
import './index.css';
import {GET_SCHOOL_ARTICLES_PUBLISHED} from "../../../api";

class SelectArticlesModal extends PureComponent {

	constructor(props){
		super(props);
		this.state = {
			loading: false,
			articles: null,
			error: null,
			pagination: null,
			selectedArticles: this.props.existingArticles,
		}
	}

	componentDidMount(): void {
		this.getPublishedArticles();
	}

	getPublishedArticles = (url) => {
		this.setState({loading: true});
		getPublishedArticles(url)
			.then((request) => {
				this.setState({
					loading: false,
					articles: request.data,
					pagination: request.pagination,
				})
			})
			.catch((error) => {
				this.setState({
					loading: false,
					error
				})
			})
	};

	onArticleClicked = (article) => {
		if(this.isArticleSelected(article.id)) {
			const articles = this.state.selectedArticles.filter(value => article.id !== value.id);
			this.setState({
				selectedArticles: articles,
			})
		} else {
			const articles = this.state.selectedArticles? [...this.state.selectedArticles, article] : [article];
			this.setState({
				selectedArticles: articles,
			})
		}
	};

	isArticleSelected = (id) => {
		if(!this.state.selectedArticles) return false;
		return this.state.selectedArticles.some(((value, index) => {
			return value.id === id;
		}))
	};

	getRowClasses = (id, text = false) => {
		if(this.isArticleSelected(id)) {
			if(text) return "row-selected text-color";
			return 'row-selected'
		}
	};

	getEditModalValues = () => {
		return this.state.selectedArticles;
	};

	renderPaginationButtons() {
		const {pagination} = this.state;
		if(pagination) {
			return (
				<Pagination
					totalPages={pagination.last_page}
					currentPage={pagination.current_page}
					baseUrl={Config.urlApi + GET_SCHOOL_ARTICLES_PUBLISHED}
					onPageChanged={(url) => {
						this.getPublishedArticles(url)
					}}
				/>
			)
		}
	}

	renderEmptyArticleList() {
		if (this.state.error) {
			return (
				<p>Ocorreu um error a mostrar os artigos</p>
			)
		} else {
			return (
				<p>Não existem artigos</p>
			)
		}
	}

	renderRows() {
		const {loading, articles} = this.state;
		if (!loading) {
			if (articles !== null) {
				if (articles.length > 0) {
					return articles.map((e, i) =>
						<tr
							key={e.id}
							onClick={() => {this.onArticleClicked(e)}}
							className={this.getRowClasses(e.id)}
						>
							<td style={{width: 30}} className={this.getRowClasses(e.id, true)}>
								<input
									type={'checkbox'}
									checked={this.isArticleSelected(e.id)}
									onChange={() => {

									}}
								/>
							</td>
							<td style={{width: 50}} className={this.getRowClasses(e.id, true)}>
								<img
									style={{height: 24}}
									src={NewsGalleryBlack}
									alt={""}
								/>
							</td>
							<td className={this.getRowClasses(e.id, true) + " table-column-list-articles-title"}>{e.title}</td>
							<td style={{width: 150}} className={this.getRowClasses(e.id, true)}>{e.author}</td>
							<td style={{width: 100}} className={this.getRowClasses(e.id, true)}>{e.scheduleDate}</td>
						</tr>
					)
				}
			}
			return (
				<tr>
					<td colSpan={5}>
						<div align={"center"}>
							{this.renderEmptyArticleList()}
						</div>
					</td>
				</tr>
			)

		} else {
			return (
				<tr>
					<td colSpan={5}>
						<div className="approve-articles-loading-container" align={"center"}>
							<Loading size={"small-spinner"}/>
						</div>
					</td>
				</tr>
			)
		}
	}

	render() {
		const {t} = this.props;

		return (
			<SuperModal
				size={"lg"}
				title={"Artigos - " + this.props.title}
				onCloseModal={this.props.onModalClosed}
				onOkPressed={() => {this.props.onPositiveActionButtonPressed(this.getEditModalValues())}}
				okButtonText={t("Conclude Selection")}
			>
				<div>
					<Table striped responsive="sm">
						<thead>
						<tr>
							<th></th>
							<th></th>
							<th>{t("Title")}</th>
							<th>{t("Author")}</th>
							<th>{t("Submission")}</th>
						</tr>
						</thead>
						<tbody>
						{this.renderRows()}
						</tbody>
					</Table>
					{this.renderPaginationButtons()}
				</div>
			</SuperModal>
		);
	}
}

SelectArticlesModal.propTypes = {
	onModalClosed: PropTypes.func.isRequired,
	onPositiveActionButtonPressed: PropTypes.func.isRequired,
	existingArticles: PropTypes.array.isRequired,
	title: PropTypes.string,
};

SelectArticlesModal.defaultProps = {
	loading: false,
	existingArticles: null,
	title: null,
};

const mapStateToProps = store => ({});

const mapFunctionsToProps = {};

export default Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(SelectArticlesModal));